<template>
    <svg
        id="I_payment_solid__riverty_theme"
        data-name="I_payment_solid_ riverty_theme"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 24 24"
        preserveAspectRatio="xMidYMid meet">
        <defs>
            <clipPath :id="`clip-path-${uniqueId}`">
                <rect id="Rectangle_319" data-name="Rectangle 319" width="24" height="24" rx="6" fill="#fff" />
            </clipPath>
        </defs>
        <g
            id="Icons_I_payment_solid__riverty_theme"
            data-name="Icons / I_payment_solid_ riverty_theme"
            :clip-path="`url(#clip-path-${uniqueId})`">
            <path
                id="Path_335"
                data-name="Path 335"
                d="M1.757,22.243C3.515,24,6.343,24,12,24s8.485,0,10.243-1.757S24,17.657,24,12s0-8.485-1.757-10.243S17.657,0,12,0,3.515,0,1.757,1.757,0,6.343,0,12,0,20.485,1.757,22.243Z"
                fill="rgba(255,255,255,0)" />
            <g id="Group_1460" data-name="Group 1460">
                <rect
                    id="Rectangle_317"
                    data-name="Rectangle 317"
                    width="3.375"
                    height="10.125"
                    transform="translate(5.625 9)"
                    fill="#527a42" />
                <rect
                    id="Rectangle_318"
                    data-name="Rectangle 318"
                    width="10.125"
                    height="3.375"
                    transform="translate(9 5.625)"
                    fill="#527a42" />
            </g>
            <g id="Group_1461" data-name="Group 1461" style="mix-blend-mode: color; isolation: isolate">
                <rect
                    id="Rectangle_317-2"
                    data-name="Rectangle 317"
                    width="3.375"
                    height="10.125"
                    transform="translate(5.625 9)"
                    fill="#bfbca5" />
                <rect
                    id="Rectangle_318-2"
                    data-name="Rectangle 318"
                    width="10.125"
                    height="3.375"
                    transform="translate(9 5.625)"
                    fill="#bfbca5" />
            </g>
        </g>
    </svg>
</template>

<script lang="ts" setup>
    const uniqueId = useId();
</script>
